<template>
  <div class="row">
    <div class="col-md-12">
      <create-reward-form @on-submit="onCreateRewardSubmit"></create-reward-form>
    </div>
  </div>
</template>
<script>
  import CreateRewardForm from './Forms/CreateRewardForm.vue'

  export default {
    components: {
      CreateRewardForm
    },
    data () {
      return {

        createRewardModel: {}
      }
    },
    methods: {

      onCreateRewardSubmit (model, isValid, validateObject) {
        model.saveRewardButtonText = 'Saving Reward ...'
        this.$http.post('/plugin/rewards/add', {
          
          
          generalPoint: model.generalPoint,
          businessName: model.businessName,
          narrationName: model.narrationName,
          
        })
        .then(response =>{
          if(response.data.created_at){
            model.saveRewardButtonText = 'Reward Saved.'

            this.$nextTick(function () {
              validateObject.reset()
            })
          }else{
            model.saveRewardButtonText = 'Transaction Was Not Saved.'
          }
        })
        .catch(error => {
          console.error(error);
        });
      },

      getTransactionID () {
        var currentTimestamp = Date.now()
        return currentTimestamp
      }
    }
  }
</script>
<style>
</style>
